export const getRandomSuccessTitleKey = () => {
  const randomTitleKey = ['a', 'b', 'c'].sort(() => Math.random() - 0.5)[0];
  return `popup.success.title_${randomTitleKey}`;
};
